import './Banner.css'

function Banner(){
    return(
        <header className="banner">
            <img src="/imagens/banner.png" alt="banner" />
        </header>
    )
    
}


export default Banner;